/**
 * Web sitesi bölümünün biçimleyicileri. Bütün saatler BAE saatiyle (UTC+4): ekranda "bugün" ve
 * "dün" tarayıcının bulunduğu yere göre değil, ekibin çalıştığı saate göre okunmalı.
 */

const BAE = 'Asia/Dubai';

function parcalar(an: Date): { y: string; m: string; d: string; h: string; dk: string } {
  const f = new Intl.DateTimeFormat('en-GB', {
    timeZone: BAE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  });
  const o: Record<string, string> = {};
  for (const p of f.formatToParts(an)) o[p.type] = p.value;
  return { y: o['year'] ?? '', m: o['month'] ?? '', d: o['day'] ?? '', h: o['hour'] ?? '', dk: o['minute'] ?? '' };
}

/** `07.10.2026 08:40` */
export function tarihSaatBae(deger: string | Date): string {
  const p = parcalar(typeof deger === 'string' ? new Date(deger) : deger);
  return `${p.d}.${p.m}.${p.y} ${p.h}:${p.dk}`;
}

/** `07.10.2026` */
export function gunBae(deger: string | Date): string {
  return tarihSaatBae(deger).slice(0, 10);
}

/** `07.10` */
export function gunAyBae(deger: string | Date): string {
  return tarihSaatBae(deger).slice(0, 5);
}

/** Ondalık virgüllü, tek basamak: `14,6`. */
export function bir(n: number): string {
  return String(Math.round(n * 10) / 10).replace('.', ',');
}

/** Bir günden kısa süre saat olarak, uzun süre gün olarak. */
export function yasMetni(gun: number): string {
  return gun < 1 ? `${Math.max(1, Math.round(gun * 24))} saat` : `${Math.floor(gun)} gün`;
}

/** `3.273 AED`: tutarlar toplanmıyor, para birimi yanında. */
export function tutarMetni(altBirim: number, kod: string): string {
  const ana = altBirim / 100;
  const sayi = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: ana % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 }).format(ana);
  return `${sayi} ${kod}`;
}

/** Bir metni, eşleşen aralığa göre üçe böler: önce, eşleşen, sonra. Aralık yoksa tek parça. */
export function vurguParcalari(metin: string, aralik: [number, number] | undefined): [string, string, string] {
  if (!aralik) return [metin, '', ''];
  const [b, s] = aralik;
  // Sunucu konumları UTF-16 birimiyle (`indexOf`) veriyor; burada da aynı birim. Sınır dışı bir
  // aralık sessizce yanlış yeri boyamasın.
  if (b < 0 || s > metin.length || b >= s) return [metin, '', ''];
  return [metin.slice(0, b), metin.slice(b, s), metin.slice(s)];
}
